// extracted by mini-css-extract-plugin
export var formContainer = "AuthFormWrapper-module--formContainer--7NUOA";
export var formContent = "AuthFormWrapper-module--formContent--Mvw2W";